module.exports = __webpack_public_path__ + "img/log-out.0b213258.svg";